<template>
  <v-theme-provider light>
    <div class="section-hero-hears" id="section-hero-hears">
      <v-row align="center" justify="center" class="mt-5">
        <v-col offset="1">
          <p class="display-2 mb-12 mt-12">
            <v-icon class="blink" color="primary">mdi-color-helper</v-icon>Patrowl<span class="font-weight-bold primary--text">Hears</span>
          </p>
          <span class="display-3 font-weight-black row-herotext" >Vulnerability Intelligence Center</span>
          <p class="headline mt-5 mb-12">
            Real-time vulnerability and threat intelligence platform, on steroids.
          </p>
          <p class="text-left">
            <v-btn outlined class="mr-2" to="/get-started">Free Trial</v-btn>
            <v-btn raised elevation="4" color="primary" to="/login?s=patrowlhears">Login<v-icon right>mdi-arrow-right-bold</v-icon></v-btn>
          </p>

        </v-col>
        <v-col align="end">
          <v-img max-width="735" :src="hero_img" class="my-10"></v-img>
        </v-col>
      </v-row>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SecHeroHears",
  data: () => ({
    hero_img: require('@/assets/screenshots/patrowlhears/patrowlhears-hero.png'),
  })
};
</script>

<style scoped>
/* @media only screen and (max-width : 374px) {
   .section-hero-container {
      height: 450px;
      background-position: 27% 8px;
   }
   .row-herotext {
     height: 40px;
   }
   .row-punchline {
     height: 30px;
   }
}

.row-punchline {
  height: 350px;
}
*/
/* .section-hero-hears {
  height: 475px;
} */
.row-herotext {
  height: 700px;
}
</style>
